export class CreateDashboardInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDashboardInput.attributeTypeMap;
    }
    constructor() {
    }
}
